/**
 * File: HomePage.js
 * Origin: isotect
 * Description: [TODO: Description]
 *
 * Version: v1.7.1
 * Created: 2025-07-23
 * Last Updated: 2026-06-22
 *
 * Used By: isotect
 * Maintainer: Zachary Dicks
 *
 * Notes:
 * - Changes in this file may affect all consuming frontend modules.
 * - See Git repository 'isotect' for full change history.
 */

// Third-party packages
import { useNavigate } from "react-router-dom";
import { useState } from "react";

// Local project files
import { ChatButton } from "../components/ui/Buttons";
import { ModelHero } from "../components/layout/Hero";
import { routes } from "../constants/routes";
import ContactModal from "../components/layout/ContactModal";
import QuoteModal from "../components/layout/QuoteModal";

/**
 * [TODO: Component description here]
 *
 * @returns {JSX.Element} [TODO: Rendered output]
 */
function HomePage({ schema }) {
    const navigate = useNavigate();

    const [contactModal, setContactModal] = useState(false);
    const [quoteModal, setQuoteModal] = useState(false);

    const redirectSignUpPage = () => {
        navigate(routes.public.auth.signUp.abs);
    };

    const toggleContactModal = () => {
        setContactModal((prev) => !prev);
    };

    const closeContactModal = () => {
        setContactModal(false);
    };

    const toggleQuoteModal = () => {
        setQuoteModal((prev) => !prev);
    };

    const closeQuoteModal = () => {
        setQuoteModal(false);
    };

    return (
        <>
            {quoteModal && <QuoteModal onClose={closeQuoteModal} />}
            {contactModal && <ContactModal onClose={closeContactModal} />}
            <ChatButton onClick={toggleContactModal} />

            <div className="home-page">
                <article className="home-page__hero-article u-fade-in">
                    <div className="home-page__container">
                        <ModelHero
                            {...schema.hero}
                            primaryOnClick={redirectSignUpPage}
                            secondaryOnClick={toggleQuoteModal}
                        />
                    </div>
                </article>
            </div>
        </>
    );
}

export default HomePage;
